import { Record } from 'immutable';

export const OptionUserFactory = new Record({
  label: '',
  value: '',
  picture: null,
  type: 'user',
});

export const OptionEventFactory = new Record({
  label: '',
  value: '',
  type: 'event',
});

export const ChipTextFactory = new Record({
  label: '',
  value: '',
  type: 'text',
});

export const ChipDateFactory = new Record({
  label: '',
  value: '',
  type: 'date',
});
